import React, { useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  Box,
  CircularProgress,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useNavigate } from "react-router";

export default function AddArticleCard({ articles = [], onSelectArticle, message="Add an Article" }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const filteredArticles = articles.filter((article) =>
    article.title.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (article) => {
    onSelectArticle(article);
    setOpen(false);
  };

//   staff/articles/

const handleNewArticle = (e) => {
    // onSelectArticle(article);
    // setOpen(false);
    navigate("/staff/articles/",{state: {redirect:"create-article"}})
  };

  return (
    <>
      {/* Placeholder Card */}
      <Card
        sx={{
          width: 200,
          height: 120,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: 3,
          borderRadius: 2,
          transition: "0.3s",
          marginBottom:1,
          "&:hover": { boxShadow: 6 },
        }}
        onClick={handleOpen}
      >
        <CardActionArea sx={{ height: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#1976d2",
            }}
          >
            <AddCircleOutlineIcon sx={{ fontSize: 64, mb: 1 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              {message}
            </Typography>
          </Box>
        </CardActionArea>
      </Card>

      {/* Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Select or Search Article</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Search Articles"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Box sx={{ mt: 2 }}>
            {loading ? (
              <Box
                sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 3 }}
              >
                <CircularProgress />
              </Box>
            ) : filteredArticles.length > 0 ? (
              <List>
                {filteredArticles.map((article) => (
                  <ListItem
                    button
                    key={article.id}
                    onClick={() => handleSelect(article)}
                  >
                    <ListItemText
                      primary={article.title}
                      secondary={article.category || ""}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No articles found.
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleNewArticle}>New Article</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
